import React, { useState, useEffect, useRef } from 'react';
import { faPaperPlane, faStop } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

function InputArea({ onSend, onStop, questionText, setQuestionText, disableSendButton, isStreaming, placeholder = "Type your question..." }) {
  const [input, setInput] = useState('');
  const textareaRef = useRef(null);

  useEffect(() => {
    setInput(questionText);
  }, [questionText]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (input.trim()) {
      onSend(input);
      setInput('');
      setQuestionText('');
    }
  };

  const handleInputChange = (e) => {
    setInput(e.target.value);
    setQuestionText(e.target.value);
  };

  return (
    <div className="input-area custom_input_area">
      <textarea
        ref={textareaRef}
        type="text"
        value={input}
        name="question"
        onChange={handleInputChange}
        placeholder={placeholder}
      />
      {isStreaming ? (
        <button
          className="send-button custom_send_button stop-button"
          onClick={onStop}
          title="Stop generating"
        >
          <FontAwesomeIcon icon={faStop} />
        </button>
      ) : (
        <button
          className={`send-button custom_send_button ${disableSendButton ? 'disabled' : ''}`}
          onClick={handleSubmit}
          disabled={disableSendButton}
        >
          <FontAwesomeIcon icon={faPaperPlane} />
        </button>
      )}
    </div>
  );
}

export default InputArea;
